import React__default from 'react';
import { useApplicationContext, Application } from '../../../../containers/ApplicationContext/index.js';
import MessageBubble from '../../../MessageBubble/index.js';
import { SharedRichCardEvents } from '../../../../containers/RichCardEventEmitter/SharedEventData/index.js';
import { useRichCardEventEmitter } from '../../../../containers/RichCardEventEmitter/index.js';
import SellableWithTitle from '../components/SellableWithTitle/index.js';
import styles from './styles.css.js';

var SellableTopListPage = function SellableTopListPage(_a) {
  var message = _a.message,
      conversationStarterMessage = _a.conversationStarterMessage,
      sourcePage = _a.sourcePage;
  var sellableTopList = sourcePage.sellableTopList;
  var sellable = sourcePage.sellableTopListSellable;
  var richCardEventEmitter = useRichCardEventEmitter();
  var application = useApplicationContext().application;
  return React__default.createElement(MessageBubble, {
    message: message,
    fullWidth: true
  }, React__default.createElement("div", {
    className: styles.container
  }, sellable ? React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: styles.innerMessageBubble
  }, React__default.createElement(SellableWithTitle, {
    sellable: sellable
  })), React__default.createElement("div", {
    className: styles.copyRow
  }, "I have a question about this:"), React__default.createElement("div", {
    className: styles.messageRow
  }, conversationStarterMessage)) : React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: styles.innerMessageBubble
  }, React__default.createElement("div", {
    className: styles.container
  }, React__default.createElement("div", {
    className: styles.clickableTitle,
    onClick: function onClick() {
      if (application === Application.CONSUMER || application === Application.BUSINESS) {
        richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
          type: SharedRichCardEvents.VIEW_SELLABLE_TOP_LIST,
          slug: sellableTopList.slug,
          friendlyId: sellableTopList.friendlyId,
          url: sellableTopList.consumerUrl
        });
      }
    }
  }, sellableTopList.title))), React__default.createElement("div", {
    className: styles.copyRow
  }, "I have a question about this:"), React__default.createElement("div", {
    className: styles.messageRow
  }, conversationStarterMessage))));
};

export default SellableTopListPage;
//# sourceMappingURL=index.js.map
